module.exports = __webpack_public_path__ + "static/media/person-icon-dark.0630a598.svg";